import React from 'react'

const Star = ({ color = '#FFB338' }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9083 4.85828C12.1083 5.26662 12.6416 5.65828 13.0916 5.73328L15.7499 6.17495C17.4499 6.45828 17.8499 7.69162 16.6249 8.90828L14.5583 10.975C14.2083 11.325 14.0166 12 14.1249 12.4833L14.7166 15.0416C15.1833 17.0666 14.1083 17.85 12.3166 16.7916L9.82492 15.3166C9.37492 15.05 8.63326 15.05 8.17492 15.3166L5.68326 16.7916C3.89992 17.85 2.81659 17.0583 3.28326 15.0416L3.87492 12.4833C3.98326 12 3.79159 11.325 3.44159 10.975L1.37492 8.90828C0.158257 7.69162 0.549924 6.45828 2.24992 6.17495L4.90826 5.73328C5.34992 5.65828 5.88326 5.26662 6.08326 4.85828L7.54992 1.92495C8.34992 0.333285 9.64992 0.333285 10.4416 1.92495L11.9083 4.85828Z'
        fill={color}
      />
    </svg>
  )
}

export default Star
